import {
    CreateNewTagRequest,
    CreateNewTagResponse,
    DeleteTagRequest,
    UpdateTagRequest,
    UpdateTagResponse,
} from "@lifeat/shared/task-management/TaskTagFunctionContracts";
import { callMonolith } from "@service/ServerlessFunctionsService";

/**
 * Service for Task Tag related operations.
 */
export class TaskTagService {
    /**
     * Makes a request to the serverless function to create a new tag.
     * @param createTagRequest
     * @returns {Promise<CreateNewTagResponse>} Response containing the
     *  tag ID and tag item
     */
    static async createNewTag(createTagRequest: CreateNewTagRequest): Promise<CreateNewTagResponse | null> {
        try {
            return await callMonolith("create-new-tag", createTagRequest);
        } catch (err) {
            console.log(`Error creating tag: ${err}`);
            throw err;
        }
    }

    static async updateTag(updateTagRequest: UpdateTagRequest): Promise<UpdateTagResponse> {
        try {
            return await callMonolith("update-tag", updateTagRequest);
        } catch (err) {
            console.log(`Error updating tag: ${err}`);
            throw err;
        }
    }

    /**
     * Makes a request to the serverless function to delete a tag.
     * @param tagId ID of the tag to delete.
     */
    static async deleteTag(tagId: string): Promise<void> {
        try {
            const payload: DeleteTagRequest = {
                tagId: tagId,
            };
            await callMonolith("delete-tag", payload);
        } catch (err) {
            console.log(`Error deleting tasks: ${err}`);
            throw err;
        }
    }
}
